<template>
    
    <div>

        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-6">
            <b-button v-b-modal.payerSelectModal v-on:click="clearData()">Select Payer</b-button>
        </base-header>
        <div class="container-fluid mt--7">
            <payer-performance-charts :BIN="submitBIN" :PCN="submitPCN" :GroupNumber="submitGroupNumber"></payer-performance-charts>
        </div>
        <b-modal no-close-on-backdrop
                 ref="payerSelectModal"
                 id="payerSelectModal"
                 title="Payer Select"
                 @ok="submitPayerSelectForm">
            <form ref="payerSelectForm">
                <span>BIN</span>
                <v-select :options="BINs" v-model="selectedBIN"></v-select>
                <span>PCN</span>
                <v-select :options="PCNs" v-model="selectedPCN"></v-select>
                <span>Group Number</span>
                <v-select :options="GroupNumbers" v-model="selectedGroupNumber"></v-select>
            </form>
        </b-modal>

    </div>
</template>
<script>
    // Charts
    import PayerPerformanceCharts from '@/components/Charts/PayerPerformanceCharts';

    export default {
        components: {
            PayerPerformanceCharts,
        },
        data() {
            return {
                accessiblePayers: [],
                selectedBIN: '',
                selectedPCN: '',
                selectedGroupNumber: '',
                submitBIN: '',
                submitPCN: '',
                submitGroupNumber: '',
                BINs: [],
                PCNs: [],
                GroupNumbers: [],
                PayerPerformance: []

            };
        },
        methods: {
            clearData() {
                this.submitBIN = ''
                this.submitPCN = ''
                this.submitGroupNumber = ''
            },
            showModal() {
                this.$refs['payerSelectModal'].show()
            },
            hideModal() {
                this.$refs['payerSelectModal'].hide()
            },
            submitPayerSelectForm() {
                this.submitBIN = this.selectedBIN;
                this.submitPCN = this.selectedPCN;
                this.submitGroupNumber = this.selectedGroupNumber
            },

        },
        mounted() {
            this.axios.get(`CompanyStats/GetDistinctPayers`)
                .then(response => {
                    this.accessiblePayers = response.data
                    this.selectedBIN = this.accessiblePayers[0].bin
                    this.selectedPCN = this.accessiblePayers[0].pcn
                    this.selectedGroupNumber = this.accessiblePayers[0].groupNumber

                    this.BINs = this.accessiblePayers.map(a => a.bin)
                    this.BINs = Array.from(new Set(this.BINs)).sort()

                    this.PCNs = this.accessiblePayers.map(a => a.pcn)
                    this.PCNs = Array.from(new Set(this.PCNs)).sort()

                    this.GroupNumbers = this.accessiblePayers.map(a => a.groupNumber)
                    this.GroupNumbers = Array.from(new Set(this.GroupNumbers)).sort()

                })
                .catch(error => {
                    
                });
            this.showModal()
        }
    };
</script>
<style></style>
